import { render, staticRenderFns } from "./SpecialPriceAdjList.vue?vue&type=template&id=1106ef72&"
import script from "./SpecialPriceAdjList.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports